import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function TrailingNeutral({ size, ...props }) {
  return (
    <SvgIconComponent
      height="21"
      width="21"
      fill="none"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M10.498 1.49951C15.4686 1.49951 19.498 5.52895 19.498 10.4995C19.498 15.4701 15.4686 19.4995 10.498 19.4995C5.52749 19.4995 1.49805 15.4701 1.49805 10.4995C1.49805 5.52895 5.52748 1.49951 10.498 1.49951Z"
        stroke="#2D323B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M10.4941 10.499L10.4941 14.999"
        stroke="#141A21"
        strokeLinecap="round"
        strokeWidth="2.2"
      />
      <path
        d="M10.5018 5.99951C10.665 5.99951 10.8185 6.03231 10.9622 6.09788C11.1124 6.15687 11.2397 6.24215 11.3442 6.35362C11.4553 6.45854 11.5402 6.58638 11.5989 6.73723C11.6642 6.8815 11.6969 7.03557 11.6969 7.19951C11.6969 7.35691 11.6642 7.50772 11.5989 7.65199C11.5402 7.79626 11.4553 7.92411 11.3442 8.03561C11.2397 8.14707 11.1124 8.23561 10.9622 8.30118C10.8185 8.36675 10.665 8.39951 10.5018 8.39951C10.345 8.39951 10.1916 8.36675 10.0414 8.30118C9.89769 8.24215 9.77034 8.16016 9.65932 8.05524C9.5483 7.94378 9.46014 7.81593 9.39483 7.67166C9.32953 7.52085 9.29687 7.36345 9.29687 7.19951C9.29687 7.03557 9.32953 6.8815 9.39483 6.73723C9.46014 6.58638 9.54504 6.45854 9.64953 6.35362C9.76055 6.24215 9.88789 6.15687 10.0316 6.09788C10.1818 6.03231 10.3385 5.99951 10.5018 5.99951Z"
        fill="#2D323B"
      />
    </SvgIconComponent>
  )
}

export function TrailingInfo({ size, ...props }) {
  return (
    <SvgIconComponent
      height="21"
      width="21"
      fill="none"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M10.6981 1.49951C15.6686 1.49951 19.6981 5.52895 19.6981 10.4995C19.6981 15.4701 15.6686 19.4995 10.6981 19.4995C5.7275 19.4995 1.69806 15.4701 1.69806 10.4995C1.69806 5.52895 5.7275 1.49951 10.6981 1.49951Z"
        stroke="#5485D3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M10.6942 10.499L10.6942 14.999"
        stroke="#5485D3"
        strokeLinecap="round"
        strokeWidth="2.2"
      />
      <path
        d="M10.7018 5.99951C10.8651 5.99951 11.0185 6.03231 11.1622 6.09788C11.3124 6.15687 11.4397 6.24215 11.5442 6.35362C11.6553 6.45854 11.7402 6.58638 11.7989 6.73723C11.8643 6.8815 11.8969 7.03557 11.8969 7.19951C11.8969 7.35691 11.8643 7.50772 11.7989 7.65199C11.7402 7.79626 11.6553 7.92411 11.5442 8.03561C11.4397 8.14707 11.3124 8.23561 11.1622 8.30118C11.0185 8.36675 10.8651 8.39951 10.7018 8.39951C10.545 8.39951 10.3916 8.36675 10.2414 8.30118C10.0977 8.24215 9.97036 8.16016 9.85933 8.05524C9.74831 7.94378 9.66015 7.81593 9.59484 7.67166C9.52954 7.52085 9.49689 7.36345 9.49689 7.19951C9.49689 7.03557 9.52954 6.8815 9.59484 6.73723C9.66015 6.58638 9.74505 6.45854 9.84954 6.35362C9.96056 6.24215 10.0879 6.15687 10.2316 6.09788C10.3818 6.03231 10.5385 5.99951 10.7018 5.99951Z"
        fill="#5485D3"
      />
    </SvgIconComponent>
  )
}

export function TrailingWarning({ size, ...props }) {
  return (
    <SvgIconComponent
      height="21"
      width="21"
      fill="none"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M10.9 19.5C5.92946 19.5 1.90002 15.4706 1.90002 10.5C1.90002 5.52944 5.92946 1.5 10.9 1.5C15.8706 1.5 19.9 5.52944 19.9 10.5C19.9 15.4706 15.8706 19.5 10.9 19.5Z"
        stroke="#F98A3E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M10.8981 6.5V10.5"
        stroke="#F98A3E"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M10.9038 12.5C11.067 12.5 11.2205 12.5328 11.3641 12.5984C11.5144 12.6574 11.6417 12.7426 11.7462 12.8541C11.8572 12.959 11.9421 13.0869 12.0009 13.2377C12.0662 13.382 12.0989 13.5361 12.0989 13.7C12.0989 13.8574 12.0662 14.0082 12.0009 14.1525C11.9421 14.2967 11.8572 14.4246 11.7462 14.5361C11.6417 14.6476 11.5144 14.7361 11.3641 14.8017C11.2205 14.8672 11.067 14.9 10.9038 14.9C10.747 14.9 10.5935 14.8672 10.4433 14.8017C10.2997 14.7426 10.1723 14.6607 10.0613 14.5557C9.95028 14.4443 9.86212 14.3164 9.79681 14.1722C9.7315 14.0213 9.69885 13.8639 9.69885 13.7C9.69885 13.5361 9.7315 13.382 9.79681 13.2377C9.86212 13.0869 9.94701 12.959 10.0515 12.8541C10.1625 12.7426 10.2899 12.6574 10.4335 12.5984C10.5838 12.5328 10.7405 12.5 10.9038 12.5Z"
        fill="#F98A3E"
      />
    </SvgIconComponent>
  )
}

export function TrailingError({ size, ...props }) {
  return (
    <SvgIconComponent
      height="21"
      width="21"
      fill="none"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M10.1 19.5C5.12941 19.5 1.09998 15.4706 1.09997 10.5C1.09997 5.52944 5.12941 1.5 10.1 1.5C15.0705 1.5 19.1 5.52944 19.1 10.5C19.1 15.4706 15.0705 19.5 10.1 19.5Z"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M10.098 6.5V10.5"
        stroke="#D64949"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M10.1037 12.5C10.267 12.5 10.4205 12.5328 10.5641 12.5984C10.7143 12.6574 10.8417 12.7426 10.9461 12.8541C11.0572 12.959 11.1421 13.0869 11.2008 13.2377C11.2662 13.382 11.2988 13.5361 11.2988 13.7C11.2988 13.8574 11.2662 14.0082 11.2008 14.1525C11.1421 14.2967 11.0572 14.4246 10.9461 14.5361C10.8417 14.6476 10.7143 14.7361 10.5641 14.8017C10.4205 14.8672 10.267 14.9 10.1037 14.9C9.94697 14.9 9.7935 14.8672 9.64329 14.8017C9.49962 14.7426 9.37227 14.6607 9.26125 14.5557C9.15023 14.4443 9.06207 14.3164 8.99676 14.1722C8.93145 14.0213 8.8988 13.8639 8.8988 13.7C8.8988 13.5361 8.93145 13.382 8.99676 13.2377C9.06207 13.0869 9.14697 12.959 9.25146 12.8541C9.36248 12.7426 9.48982 12.6574 9.6335 12.5984C9.7837 12.5328 9.94044 12.5 10.1037 12.5Z"
        fill="#D64949"
      />
    </SvgIconComponent>
  )
}

export function TrailingSuccess({ size, ...props }) {
  return (
    <SvgIconComponent
      height="21"
      width="21"
      fill="none"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M6.29993 10.9988L9.00178 13.7537L14.2999 8.5"
        stroke="#8DC953"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M10.2999 1.5C15.2705 1.5 19.2999 5.52944 19.2999 10.5C19.2999 15.4706 15.2705 19.5 10.2999 19.5C5.32936 19.5 1.29993 15.4706 1.29993 10.5C1.29993 5.52944 5.32936 1.5 10.2999 1.5Z"
        stroke="#8DC953"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SvgIconComponent>
  )
}

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}

TrailingNeutral.propTypes = iconPropTypes
TrailingInfo.propTypes = iconPropTypes
TrailingWarning.propTypes = iconPropTypes
TrailingError.propTypes = iconPropTypes
TrailingSuccess.propTypes = iconPropTypes

const iconsStaticBanner = {
  TrailingNeutral,
  TrailingInfo,
  TrailingWarning,
  TrailingError,
  TrailingSuccess
}

export default iconsStaticBanner
